import React, { useState } from "react";
import { Form, Row, Col, FloatingLabel, Button, Modal } from "react-bootstrap";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from "../../components/misc/LoadingSpinner";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import GLOBALVAR from "../../constants"; // Import GLOBALVAR constant

function EditLoan({ loanProcessingData, updateParentLoanProcessing }) {
    const [dateGranted, setDateGranted] = useState(null); // State to manage birthday
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errMessages, setErrMessages] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const [formData, setFormData] = useState({
        id: loanProcessingData?loanProcessingData.id:'',
        loanProcessingType: loanProcessingData?loanProcessingData.loanProcessingType:'',
        amountGranted: loanProcessingData?loanProcessingData.amountGranted:'',
        dateGranted: loanProcessingData?loanProcessingData.dateGranted:'',
        interestRate: loanProcessingData?loanProcessingData.interestRate:'',
        loanTerm: loanProcessingData?loanProcessingData.loanTerm:'',
        paymentType: loanProcessingData?loanProcessingData.paymentType:'',
        loanInterval: loanProcessingData?loanProcessingData.loanInterval:'',
        accountOfficer: loanProcessingData?loanProcessingData.accountOfficer:'',
        loanProduct: loanProcessingData?loanProcessingData.loanProduct:'',
        loanLedger: loanProcessingData?loanProcessingData.loanLedger:'',
        loanSecurity: loanProcessingData?loanProcessingData.loanSecurity:'',
        reference: loanProcessingData?loanProcessingData.reference:'',
        loanType: loanProcessingData?loanProcessingData.loanType:'',
        addtl_beneficiary: loanProcessingData?loanProcessingData.addtl_beneficiary:'',
        addtl_contact: loanProcessingData?loanProcessingData.addtl_contact:'',
        addtl_relationship: loanProcessingData?loanProcessingData.addtl_relationship:'',
        applicant: loanProcessingData?loanProcessingData.applicant:''
    });

    const handleDateChange = (date) => {
        if(!date) return;

        setDateGranted(date);
        const formattedDate = format(date, 'MM/dd/yyyy'); 
        handleChangeInput({ target: { name: "dateGranted", value: formattedDate } });
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);

        console.log(formData);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/update/${formData.id}`, formData);
            setModalHeader('Success');
            setModalBody(response.data.message);
            handleShow();
            setShowSpinner(false);

            updateParentLoanProcessing(formData);
        } catch (error) {
            console.error('Error updating loan processing entry:', error);
            setModalHeader('Validation Error');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
        
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                {errMessages && (
                    <Modal.Body>
                        <ul>
                            {errMessages.map((error, index) => (
                                <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
                            ))}
                        </ul>
                    </Modal.Body>
                )}
                {!errMessages && (
                    <Modal.Body>
                        {modalBody}
                    </Modal.Body>
                )}
            </Modal>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <FloatingLabel controlId="floatingLoanProcessingType" label={loanProcessingData?`Type of Loan (${loanProcessingData.loanProcessingType})`:"Type of Loan"}>
                            <Form.Select 
                            name="loanProcessingType" 
                            onChange={handleChangeInput} 
                            onBlur={handleChangeInput}
                            >
                            <option>Select Type of Loan</option>
                            <option value="new">New Loan</option>
                            <option value="reloan">Reloan</option>
                            <option value="restructure">Restructure</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <hr className="my-4"></hr>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingAmountGranted" label={loanProcessingData?`Amount Granted (${loanProcessingData.amountGranted})`:"Amount Granted"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Amount Granted" 
                            name="amountGranted" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col>
                    {dateGranted ? (
                        <DatePicker
                        className="form-control"
                        selected={dateGranted} // Set the selected date
                        onChange={(e) => {
                            handleDateChange(e);
                        }} // Handle date change
                        dateFormat="MM/dd/yyyy" // Date format
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={new Date()} // Max date is today
                        name="dateGranted"
                        />
                    ) : (
                        <FloatingLabel controlId="floatingBirthday" label={loanProcessingData?`Date Granted (${format(loanProcessingData.dateGranted, 'MM/dd/yyyy')})`:"Date Granted"}>
                        <DatePicker
                            className="form-control"
                            selected={dateGranted} // Set the selected date
                            onChange={(e) => {
                                handleDateChange(e);
                            }} // Handle date change
                            dateFormat="MM/dd/yyyy" // Date format
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            name="dateGranted"
                            />
                        </FloatingLabel>
                    )}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingInterestRate" label={loanProcessingData?`Interest Rate (${loanProcessingData.interestRate}%)`:"Interest Rate (%)"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Interest Rate" 
                            name="interestRate" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col>
                        <FloatingLabel controlId="floatingLoanTerm" label={loanProcessingData?`Loan Term (${loanProcessingData.loanTerm})`:"Loan Term"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Loan Term" 
                            name="loanTerm" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col>
                        <FloatingLabel controlId="floatingPaymentType" label={loanProcessingData?`Payment Type (${loanProcessingData.paymentType})`:"Payment Type"}>
                            <Form.Select name="paymentType" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                <option>Select Payment Type</option>
                                <option value="add">Add On</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingLoanInterval" label={loanProcessingData?`Loan Interval (${loanProcessingData.loanInterval})`:"Loan Interval"}>
                            <Form.Select name="loanInterval" onChange={handleChangeInput} onBlur={handleChangeInput}>
                                <option>Select Loan Interval</option>
                                <option value="monthly">Monthly</option>
                                <option value="bimonthly">Bi-Monthly</option>
                                <option value="weekly">Weekly</option>
                                <option value="quarterly">Quarterly</option>
                                <option value="semiannual">Semi-Annual</option>
                                <option value="yearly">Yearly</option>
                                <option value="lumpsum">Lumpsum</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <hr className="my-4"></hr>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingServiceFee" label={loanProcessingData?`Service Fee (${loanProcessingData.serviceFee})`:"Service Fee"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Service Fee" 
                            name="serviceFee" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col>
                        <FloatingLabel controlId="floatingNotarialFee" label={loanProcessingData?`Notarial Fee (${loanProcessingData.notarialFee})`:"Notarial Fee"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Notarial Fee" 
                            name="notarialFee" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingDocStamp" label={loanProcessingData?`Doc Stamp (${loanProcessingData.docStamp})`:"Doc Stamp"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Doc Stamp" 
                            name="docStamp" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col>
                        <FloatingLabel controlId="floatingInsurance" label={loanProcessingData?`Insurance (${loanProcessingData.insurance})`:"Insurance"}>
                            <Form.Control 
                            type="number" 
                            placeholder="Insurance" 
                            name="insurance" 
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <hr className="my-4"></hr>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingAccountOfficer" label={loanProcessingData?`Account Officer (${loanProcessingData.accountOfficer})`:"Account Officer"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Account Officer" 
                            name="accountOfficer" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingLoanProduct" label={loanProcessingData?`Loan Product (${loanProcessingData.loanProduct})`:"Loan Product"}>
                            <Form.Select name="loanProduct" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                <option>Select Loan Product</option>
                                <option value="regular">Regular Loan</option>
                                <option value="salary">Salary Loan</option>
                                <option value="pension">Pension Loan</option>
                                <option value="honorarium">Honorarium Loan</option>
                                <option value="market">Market Vendors</option>
                                <option value="clean">Clean Loan</option>
                                <option value="chattel">Chattel</option>
                                <option value="rem">REM</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingLoanLedger" label={loanProcessingData?`Loan Ledger (${loanProcessingData.loanLedger})`:"Loan Ledger"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Loan Ledger" 
                            name="loanLedger" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingLoanSecurity" label={loanProcessingData?`Loan Security (${loanProcessingData.loanSecurity})`:"Loan Security"}>
                            <Form.Select name="loanSecurity" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                <option>Select Loan Security</option>
                                <option value="unsecured">Unsecured</option>
                                <option value="atm">Secured with ATM</option>
                                <option value="pdc">Secured with PDC</option>
                                <option value="clean">Clean Loan</option>
                                <option value="chattel">Chattel Mortgage</option>
                                <option value="residential">Real Estate Mortgage - Residential</option>
                                <option value="commercial">Real Estate Mortgage - Commercial</option>
                                <option value="others">Others</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingLoanType" label={loanProcessingData?`Loan Type (${loanProcessingData.loanType})`:"Loan Type"}>
                            <Form.Select name="loanType" onChange={handleChangeInput} onBlur={handleChangeInput} >
                                <option>Select Loan Type</option>
                                <option value="personal">Personal Loan</option>
                                <option value="business">Business Loan</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Col>
                </Row>
                <hr className="my-4"></hr>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingBeneficiaryName" label={loanProcessingData?`Beneficiary Name (${loanProcessingData.addtl_beneficiary})`:"Beneficiary Name"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Beneficiary Name" 
                            name="addtl_beneficiary" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingContactNumber" label={loanProcessingData?`Contact Number (${loanProcessingData.addtl_contact})`:"Contact Number"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Contact Number" 
                            name="addtl_contact" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingRelationship" label={loanProcessingData?`Relationship (${loanProcessingData.addtl_relationship})`:"Relationship"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Relationship" 
                            name="addtl_relationship" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel controlId="floatingReference" label={loanProcessingData?`Reference (${loanProcessingData.reference})`:"Reference"}>
                            <Form.Control 
                            type="text" 
                            placeholder="Reference" 
                            name="reference" 
                            onKeyUp={handleChangeInput}
                            onChange={handleChangeInput}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Button variant="primary" type="submit" className="submit-btn" id="submit-processing">Update Loan</Button>
                    </Col>
                </Row>
            </Form>
        </>
    );
}

export default EditLoan;
